"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPlatformEndpoints = createPlatformEndpoints;
/**
 * Platform geneli uçlar: sağlık yoklaması, medya yükleme niyeti ve şikayet bildirimi.
 * Hiçbiri tek bir ürün alanına ait değildir; üçü de her alandan çağrılır.
 */
function createPlatformEndpoints(client) {
    return {
        health: {
            check: () => client.call('/health', 'get', {}),
        },
        media: {
            createUploadIntent: (input) => client.call('/media/upload-intents', 'post', { body: input }),
            completeUpload: (mediaId) => client.call('/media/{id}/complete', 'post', { path: { id: mediaId } }),
            get: (mediaId) => client.call('/media/{id}', 'get', { path: { id: mediaId } }),
            remove: (mediaId) => client.call('/media/{id}', 'delete', { path: { id: mediaId } }),
        },
        reports: {
            submit: (input) => client.call('/reports', 'post', { body: input }),
        },
    };
}
//# sourceMappingURL=platform.js.map